import Vue from '../../lib/vue2.js';
import './multiform.js';
import './general.js';
import './recaptcha2.js';

// Vue 2 dokumnetacija je teska za googlat
// https://devdocs.io/vue~2/api/index#mounted

new Vue({
    components: {
    },
    methods: {

    },
    mounted: function() {

    },
    data: function () {
        return {

        }
    }
}).$mount('#app_multiform');
